import React, { FC } from "react";

import { auditTable } from "../../constants/table";

import Table from "./../Table";

const Audit: FC = () => <Table table={auditTable}/>;

export default Audit;
